import { render, staticRenderFns } from "./crm-orders.vue?vue&type=template&id=6ebb5502&"
import script from "./crm-orders.vue?vue&type=script&lang=js&"
export * from "./crm-orders.vue?vue&type=script&lang=js&"
import style0 from "./crm-orders.vue?vue&type=style&index=0&id=6ebb5502&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports